import { IsArray, IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { AssetDto } from 'src/app/shared/dtos/asset.dto';

export class MachineRangeDto {
  @IsNumber()
  id: number;

  @IsString()
  name: string;

  @ValidateNested()
  @Type(() => AssetDto)
  thumbnail: AssetDto;

  @ValidateNested({ each: true })
  @Type(() => MachineDto)
  children: MachineDto[];

  @ValidateNested({ each: true })
  @Type(() => MachineGroupDto)
  groups: MachineGroupDto[];
}

export class MachineDto {
  @IsNumber()
  id: number;

  @IsString()
  title: string;

  @IsString()
  sub_heading: string;

  @ValidateNested()
  @Type(() => AssetDto)
  thumbnail: AssetDto;

  @IsOptional()
  @ValidateNested({ each: true })
  @Type(() => MachineVariantDto)
  variants?: MachineVariantDto[];

  @IsOptional()
  @IsNumber()
  ordinal: number;

  @IsOptional()
  @IsArray()
  placements: MachinePlacementDto[];
}

export class MachinePlacementDto {
  @IsNumber()
  id: number;

  @IsString()
  name: string;

  @IsArray()
  items: MachinePlacementItemDto[];
}

export class MachinePlacementItemDto {
  @IsString()
  title: string;

  @IsString()
  type: string;

  @IsBoolean()
  is_confidential: boolean;

  @ValidateNested()
  @Type(() => AssetDto)
  item: AssetDto;

  @ValidateNested()
  @Type(() => AssetDto)
  thumbnail: AssetDto;
}

export class MachineVariantDto {
  @IsNumber()
  variant_id: number;

  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  tier: string;

  @ValidateNested({ each: true })
  @Type(() => MachineVariantSpecDto)
  specs: MachineVariantSpecDto[];
}

export class MachineVariantSpecDto {
  @IsNumber()
  specification_id: number;

  @IsOptional()
  @IsNumber()
  attribute_id: number | null;

  @IsString()
  label: string;

  @IsString()
  metric_value: string;

  @IsOptional()
  @IsString()
  metric_uom: string | null;

  @IsString()
  imperial_value: string;

  @IsOptional()
  @IsString()
  imperial_uom: string | null;

  @IsString()
  type: string;

  @IsBoolean()
  is_hidden: boolean;
}

export class MachineGroupDto {
  @IsString()
  name: string;

  @IsNumber()
  ordinal: number;

  @IsArray()
  ids: number[];
}
